<template>
  <div class="u-s-sidebar mb-5">
    <div class="u-s-profile-pic" 
      :style="'background-image: url('+ $store.state.avatar +')'"
    >
      <label class="u-s-upload-btn" data-toggle="tooltip" 
        data-placement="top" title="Update profile pic">
        <i class="fa fa-camera"></i>
        <input type="file" class="d-none" @change='imageUpload($event)'>
      </label>
      <small class="text-danger" v-if="errors.image">
        {{ errors.image[0] }}
      </small>
    </div>

    <span class='u-s-nav-title'>Navigation</span>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <router-link to="/profile/edit" exact-active-class="active">
          Edit Profile
        </router-link>
      </li>
      <li class="list-group-item">
        <router-link to="/profile/change-password" active-class="active">
          Change Password
        </router-link>
      </li>
      <li class="list-group-item">
        <router-link to="/profile/invite" active-class="active">
          Invite your friend
        </router-link>
      </li>
      <li class="list-group-item">
        <router-link to="/profile/site-settings" active-class="active">
          App Settings
        </router-link>
      </li>
      <li class="list-group-item">
        <router-link to="/profile/admin-request" active-class="active">
          Admin Request
        </router-link>
      </li>
      <li class="list-group-item">
        <router-link to="/profile/player-settings" active-class="active">
          Player Settings
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { authRequest, setLocalStorage, isSmallerDevice } from '../../app/helpers';
import toastr from 'toastr';

export default {
  props: {
    redirect: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      errors: [],
    }
  },

  mounted() {
    if (!isSmallerDevice(992) && this.redirect) 
      this.$router.push({name: 'profile.edit'});
  },

  methods: {
    async imageUpload(event) {
      this.errors = [];
      const file = event.target.files[0];

      if (!file) {
        return null;
      }

      const fd = new FormData();
      fd.append('image', file, file.name);
      
      const req = await authRequest(
        this.$router,
        '/user/image_upload',
        fd,
        'post'
      );

      if (req.status) {
        toastr.success(req.message);
        this.$store.commit('avatar', req.avatar);
        setLocalStorage('avatar', req.avatar);
      } else {
        toastr.error(req.message);
        this.errors = req.errors || [];
      }
    },
  }
}
</script>